import React from 'react'
import { useUtmTracking } from '../../hooks/useUtmTracking'

const UtmTrackingProvider = ({ children }) => {
  useUtmTracking();
  return <>{children}</>
};

export default UtmTrackingProvider
